/*
Dodaje obsługę wyboru autentykacji użytkownika w ustawieniach użytkownika

Metody:
userAuthenticateConfig.init() - odpala skrypt
*/
class ApiUserAuthenticateConfig {
    static init() {
        $('.google-radio-list input:radio').on('click', function() {
            if ($(this).val() === 'none') {
                $('.authorization-type1-info').show()
                $('.authorization-type2-info').hide()
                $('.authorization-type3-info').hide()
            }
            if ($(this).val() === 'email') {
                $('.authorization-type1-info').hide()
                $('.authorization-type2-info').show()
                $('.authorization-type3-info').hide()
            }
            if ($(this).val() === 'google') {
                $('.authorization-type1-info').hide()
                $('.authorization-type2-info').hide()
                $('.authorization-type3-info').show()
            }
        });

        $('.google-radio-list input').each(function() {
            if ($(this).is(':checked') && $(this).val() === 'none') {
                $('.authorization-type1-info').show()
                $('.authorization-type2-info').hide()
                $('.authorization-type3-info').hide()
            }
            if ($(this).is(':checked') && $(this).val() === 'email') {
                $('.authorization-type1-info').hide()
                $('.authorization-type2-info').show()
                $('.authorization-type3-info').hide()
            }
            if ($(this).is(':checked') && $(this).val() === 'google') {
                $('.authorization-type1-info').hide()
                $('.authorization-type2-info').hide()
                $('.authorization-type3-info').show()
            }
        });
    };
}
